import { gql } from '@apollo/client';

const eventBidFragment = gql`
  fragment EventBidFields on AppraiserEventBid {
    EventId
    BidStatus {
      Id
      BidDate
    }
  }
`;

export default eventBidFragment;
